import { bindable } from 'aurelia-typed-observable-plugin';

export class EssHscroll {

    @bindable.number
    public scrollAmount: number = 0.5;

    private mouseOver: boolean = false;

    private scrollAreaElement!: Element;
    private scrollLeftButton!: Element;
    private scrollRightButton!: Element;

    constructor() { }

    protected handleMouseEnter(event: Event): boolean {
        this.mouseOver = true;
        this.showOrHideButtons();
        return true;
    }

    protected handleMouseLeave(event: Event): boolean {
        this.mouseOver = false;
        this.showOrHideButtons();
        return true;
    }

    protected handleMouseWheel(event: WheelEvent): boolean {
        const bounds = this.scrollAreaElement.getBoundingClientRect();
        // scroll amount is a fraction of the bounding width
        this.scrollAreaElement.scrollBy({ behavior: 'smooth', left: event.deltaY });

        return false;
    }

    protected handleButtonClick(event: Event, direction: number): boolean {
        const bounds = this.scrollAreaElement.getBoundingClientRect();
        // scroll amount is a fraction of the bounding width
        this.scrollAreaElement.scrollBy({ behavior: 'smooth', left: direction * this.scrollAmount * bounds.width });
        return false;
    }

    protected handleScroll(event: Event) {
        this.showOrHideButtons();
    }

    private showOrHideButtons() {
        let showLeft: boolean = false;
        let showRight: boolean = false;

        if(this.mouseOver) {
            const bounds = this.scrollAreaElement.getBoundingClientRect();
            const width = Math.ceil(bounds.width);
            const scrollWidth = this.scrollAreaElement.scrollWidth;
            const scrollLeft = Math.ceil(this.scrollAreaElement.scrollLeft);

            // only show buttons if the scroll width is greater than the element width
            if(this.scrollAreaElement.scrollWidth >= bounds.width) {
                // only show scroll left if not already at left
                showLeft = (scrollLeft > 0);
                // only show scroll right if not already at right
                showRight = scrollLeft < (scrollWidth - width);
            }
        }

        if(showLeft) {
            this.scrollLeftButton.classList.add('ess-hscroll-btn-active');
        }
        else {
            this.scrollLeftButton.classList.remove('ess-hscroll-btn-active');
        }

        if(showRight) {
            this.scrollRightButton.classList.add('ess-hscroll-btn-active');
        }
        else {
            this.scrollRightButton.classList.remove('ess-hscroll-btn-active');
        }
    }

}
